// extracted by mini-css-extract-plugin
export default {"tabletImg":"oO","desktopImg":"pO","mobileImg":"qO","backgroundImage":"rO","content":"sO","rtbLeft":"tO","rtbRight":"uO","imageContainer":"vO","rtbBox":"wO","line":"xO"};
    if(module.hot) {
      // 1743628927692
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  